



import { Box, Center, Flex, Grid, Icon, IconButton, Text } from "@chakra-ui/react";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";



const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => day.slice(0, -1));


const CalendarTimeframeSelect = ({
    month,year,
    setMonth,setYear,

    startDate,endDate,
    setStartDate,setEndDate
}: {
    month: number;
    year: number;

    setMonth: React.Dispatch<React.SetStateAction<number>>;
    setYear: React.Dispatch<React.SetStateAction<number>>;

    startDate: Date|null;
    endDate: Date|null;

    setStartDate: (v:Date|null) => void;    
    setEndDate: (v:Date|null) => void;
}) => {
    const currentDate = new Date();


    const onPreviousMonth = () => {
        if(month === 0) {
            setYear(year - 1)
            setMonth(11)
        } else {
            setMonth(month - 1)
        }
    }
    const onNextMonth = () => {
        if(month === 11) {
            setYear(year + 1)
            setMonth(0)
        } else {
            setMonth(month + 1)
        }
    }


    const getMonthName = (month: number) => {
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        return monthNames[month];
    };

    const getDaysInMonth = (month: number) => {
        const year = currentDate.getFullYear();
        return new Date(year, month + 1, 0).getDate();
    };


    const renderCalendar = (month: number, year:number) => {
        const daysInMonth = getDaysInMonth(month);
        const startSpacerArray = Array.from({ length: new Date(year, month, 1).getDay() })
        const endSpacerLen = 7 - ((startSpacerArray.length + daysInMonth) % 7)
        const endSpacerArray = Array.from({ length: endSpacerLen === 7 ? 0 : endSpacerLen })

        const calendarDays = [];
        for (let i = 1; i <= daysInMonth; i++) {



            const isStart = (startDate && 
                startDate.getFullYear() === year && 
                startDate.getMonth() === month && 
                startDate.getDate() === i )
            const isEnd = (endDate &&
                endDate.getFullYear() === year && 
                endDate.getMonth() === month && 
                endDate.getDate() === i )

            const isBetween = startDate && endDate && 
                new Date(year,month,i) > startDate && 
                new Date(year,month,i) < endDate


            calendarDays.push(<Center 
                key={i} h='48px' cursor='pointer'
                onClick={() => {
                    const selectedDate = new Date(year,month,i)


                    if(!startDate && !endDate) {
                        setStartDate(selectedDate)
                    } 
                    else if(
                        startDate && 
                        startDate.getFullYear() === selectedDate.getFullYear() && 
                        startDate.getMonth() === selectedDate.getMonth() && 
                        startDate.getDate() === i 
                    ) {
                        setStartDate(null)
                    }
                    else if(
                        endDate &&
                        endDate.getFullYear() === selectedDate.getFullYear() && 
                        endDate.getMonth() === selectedDate.getMonth() && 
                        endDate.getDate() === i 
                    ) {
                        setEndDate(null)
                    }
                    else if (startDate && selectedDate > startDate) { 
                        setEndDate(selectedDate); 
                    }
                    else if (startDate && selectedDate < startDate) {
                        setEndDate(null)
                        setStartDate(selectedDate)
                    }


                }}
            >
                <Center 
                    w={isBetween ? '30px' : '44px'}
                    h={isBetween ? '30px' : '44px'}
                    bg={isStart || isEnd ? '#171C22' : 
                        isBetween ? '#e8e8e9' : 'transparent' }
                    borderRadius='50%'
                >
                    <Text fontSize='lg' 
                        color={isStart || isEnd ? 'white' : 
                            isBetween ? '#171C22' : '#7E8B9A'} 
                        textAlign='center'
                    >
                        {i}
                    </Text>
                </Center>
            </Center>);
        }


        return (
            <Box>
                <Grid templateColumns="repeat(7, 1fr)" gap='4px'>
                    {startSpacerArray.map((_, index) => (
                        <Box key={`blank-${index}`} h='48px' />
                    ))}
                    {calendarDays}
                    {endSpacerArray.map((_, index) => (
                        <Box key={`blank-${index}`} h='48px' />
                    ))}
                </Grid>
            </Box>
        );
    };

    return <Box w='100%'>
        <Flex
            justifyContent='space-between' alignItems='center'
        >
            <Box>
                <Text
                    variant='title' fontSize='md'
                >{getMonthName(month)} {year}</Text>
            </Box>

            <Flex gap='5px'>
                <IconButton 
                    variant='unstyled' size='xs'
                    aria-label="previous month"
                    icon={<Icon w='18px' h='18px' as={TbChevronLeft} />}
                    onClick={() => onPreviousMonth()}
                />
                <IconButton 
                    variant='unstyled' size='xs'
                    aria-label="next month"
                    icon={<Icon w='18px' h='18px' as={TbChevronRight} />}
                    onClick={() => onNextMonth()}

                />
            </Flex>

        </Flex>
        <Flex h='42px' alignItems='end' gap='4px'>
            {daysOfWeek.map((day) => (
                <Flex key={day} flex='1' 
                    justifyContent='center'
                >
                    <Text variant='title' fontSize='10px'
                        mb='5px'
                        fontWeight='500'
                    >
                        {day}
                    </Text>
                </Flex>
            ))}
        </Flex>
        {renderCalendar(month,year)}
    </Box>
}



export default CalendarTimeframeSelect